import ResizeObserverPolyfill from 'resize-observer-polyfill'

export default (window.ResizeObserver || ResizeObserverPolyfill)
